import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/observable/throw';

import { config } from '../../../../config/index';

import { BaseWebService } from '../../shared/services/base-web.service';

@Injectable()
export class AdminDashboardService {
	to_date: any;
	from_date: any;
	patient: any = {};
	constructor(private _baseWebService: BaseWebService
	) { }

	// check if vc enabled
	getUserStatus() {
		return this._baseWebService.request("v1/va/user_status/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	/**
	 * Function for get communication history
	 */
	followUpHistory(id: any) {
		return this._baseWebService.request("v1/followup_history/" + id + "/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	followUpReferalHistory(id: any) {
		return this._baseWebService.request("v1/referral_followup_history/" + id + "/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	recentPatientFilesService(searchValue: any) {
		let searchKey = "";
		if (searchValue)
			searchKey = "&search=" + searchValue;

		return this._baseWebService.request("v1/patient_files/?limit=6&offset=0" + searchKey, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	virtualFollowUpCommunicationService(searchValue: any) {
		let searchKey = "";
		if (searchValue)
			searchKey = "&search=" + searchValue;

		return this._baseWebService.request("v1/va/vc_followup_list/?limit=6&offset=0&dashboard=true" + searchKey, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	followUpCommunicationService(searchValue: any) {
		let searchKey = "";
		if (searchValue)
			searchKey = "&search=" + searchValue;

		return this._baseWebService.request("v1/followup_communications/?limit=6&offset=0&dashboard=true" + searchKey, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	parentFollowUpCommunicationService(searchValue: any) {
		let searchKey = "";
		if (searchValue)
			searchKey = "&search=" + searchValue;

		return this._baseWebService.request("v1/parent_relapse_communications/?limit=6&offset=0&dashboard=true" + searchKey, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	patientFollowUpCommunicationService(searchValue: any) {
		let searchKey = "";
		if (searchValue)
			searchKey = "&search=" + searchValue;

		return this._baseWebService.request("v1/patient_relapse_communications/?limit=6&offset=0&dashboard=true" + searchKey, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	approvalListService(searchValue: any) {
		let searchKey = "";
		if (searchValue)
			searchKey = "&search=" + searchValue;

		return this._baseWebService.request("v1/treatment_approval/?limit=6&offset=0&status=waiting" + searchKey, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	recentPaymentListService(searchValue: any, status: any) {
		let query = 'v1/recent_payments/?limit=6&offset=0&payment_method=online';
		if (status === 'successful') {
			query = query + '&status=completed';
		} else {
			query = query + '&status=failed';
		}
		if (searchValue) {
			query = query + "&search=" + searchValue;
		}
		return this._baseWebService.request(query, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	approveTreatment = (id: any) => {
		let reqData: any = {};
		let data: any = {};
		data.docusign_redirect_url = location.origin + config.publicPath + "/docusign-approval-complete/" + id + "/";
		reqData.body = data;
		reqData.id = id;
		return this._baseWebService.request("v1/treatment_approval/" + id + "/", "put", reqData)
			.map((res: any) => res)
			.catch(this.handleError);
	}

	// get stastics report data
	getStatiticsReportData(from_date: any, to_date: any, location: any) {
		let filter = "?date_from=" + from_date + "&date_to=" + to_date
		if (location.id) {
			filter = filter + '&id_location=' + location.id;
		}
		return this._baseWebService.request("v1/report/overall_statics/" + filter, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	patientRefferalListService(searchValue: any) {
		let searchKey = "";
		if (searchValue)
			searchKey = "&search=" + searchValue;

		return this._baseWebService.request("v1/patient_referrals/?limit=6&offset=0&pending=true" + searchKey, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	paDashBoardService(location_id: any, from_date: any, to_date: any, timeFrame: any) {
		if (location_id) {
			return this._baseWebService.request("v1/dashboard_pa/?location_id=" + location_id + "&from_date=" + from_date + "&to_date=" + to_date + "&time_frame=" + timeFrame, "get")
				.map((res: any) => res)
				.catch(this.handleError);
		} else {
			return this._baseWebService.request("v1/dashboard_pa/?from_date=" + from_date + "&to_date=" + to_date + "&time_frame=" + timeFrame, "get")
				.map((res: any) => res)
				.catch(this.handleError);
		}
	}

	/**
	 * Service for get Locations
	 */
	getLocationList() {
		return this._baseWebService.request("v1/locations/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	/**
	 * Service for get TCs
	 */
	getTCList() {
		return this._baseWebService.request("v1/tc_list/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	assignBulkTCUpdate(patient: any) {
		this.patient.body = patient;
		return this._baseWebService.request("v1/patient_referral_bulk_update/", "patch", this.patient)
			.map((res: any) => res)
			.catch(this.handleError);
	}

	getGraphData = (apiUrl: string) => {
		return this._baseWebService.request(apiUrl, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	// Service to resend activation mail
	resendActivationMail() {
		return this._baseWebService.request("v1/resend_activation_mail/?origin=" + location.origin, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	//get subscription and practice details
	getSubscriptionDetails() {
		return this._baseWebService.request("v1/subscription/details/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	receivedOfflineDownPayment = (id: any,  data: any) => {
		let reqData: any = {};
		reqData.body = data;
		let query = "v1/receive_dp/" + id + "/";
		return this._baseWebService.request(query, "put", reqData)
			.map((res: any) => res)
			.catch(this.handleError);
	}

	recordDownPayment = (id: any) => {
		let reqData: any = {};
		reqData.body = {};
		let query = "v1/treatment_plan/" + id + "/record_dp/";
		return this._baseWebService.request(query, "put", reqData)
			.map((res: any) => res)
			.catch(this.handleError);
	}

	recordMonthlyPayment = (id: any) => {
		let reqData: any = {};
		reqData.body = {};
		let query = "v1/patient_monthly_payment/" + id + "/record/";
		return this._baseWebService.request(query, "put", reqData)
			.map((res: any) => res)
			.catch(this.handleError);
	}

	receivedOffline = (id: any, data: any) => {
		let reqData: any = {};
		reqData.body = {
			status: 'completed',
			payment_method: "offline",
			payment_date: data.payment_date,
			send_confirmation_mail: data.send_confirmation_mail,
		};
		let query = "v1/patient_monthly_payment/" + id + "/";
		return this._baseWebService.request(query, "put", reqData)
			.map((res: any) => res)
			.catch(this.handleError);
	}
	getTimeFrames = () => {
		return this._baseWebService.request("v1/timeframes/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	getRecentlyExpiredQuotes(searchValue: any) {
		let searchKey = "";
		if (searchValue)
			searchKey = "&search=" + searchValue;

		return this._baseWebService.request("v1/treatment_plans_expired/?limit=6&offset=0" + searchKey, "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	reviveService(id: any) {
		let url = "v1/treatment_plan/" + id + "/revive/";
		return this._baseWebService.request(url, "put")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	//get payment details 
    getPendingPaymentDetails() {
		return this._baseWebService.request("v1/pending_payments/", "get")
			.map((res: any) => res)
			.catch(this.handleError);
	}

	/**
	 * Function for cancel tracking
	 */
	cancelTracking(cancelTackingUrl: string, cancelTrackingHttpFunction: string) {
		const data: any = {};
		data.body = { is_in_follow_up: false };
		return this._baseWebService.request(cancelTackingUrl, cancelTrackingHttpFunction, data)
			.map((res: any) => res)
			.catch(this.handleError);
	}

	postponeFollowup(postponeData: any, id: any) {
        const data: any = {};
        data.body = postponeData;
        return this._baseWebService.request("v1/followup_communications/" + id + "/postpone/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

	/**
   * Function for handling service call errors
   * @param  {Response|any} error contains error data
   */
	handleError(error: Response | any) {
		return Observable.throw(error);
	}
}
